/**
 * =============================================================================
 * VideoSlider.js
 * =============================================================================

  TODO:
    On button click Play the closest video and pause any other playing videos
    Show/Hide the play button on play
    Show/Hide poster image on play
    When video is playing clicking on it will pause it and show the play button and poster image
    Video preload?
    
 * =============================================================================
 */

 class VideoSlider {
  container;

  selectors = {
    button: ".btn-wrapper",
    video: "video",
    poster: ".video-slide-poster",
    slide: ".video-slide"
  }

  // slides = [];

  /**
   * Constructor
   * @param {HTMLElement} container The video slide container
   */
  constructor(container) {
    this.container = container;

    // this.slides = this.container.querySelectorAll(this.selectors.slide);
    
    // this.slides.forEach(slide => {
    //   slide.querySelector(this.selectors.button).addEventListener("click", this.onVideoPlayButtonClick.bind(this));
    // });

    // Attach event listeners to play / pause on click and manage multiple slides
    this.container.querySelectorAll(this.selectors.button).forEach(e => {
      e.addEventListener("click", this.onVideoPlayButtonClick.bind(this));
    });
    this.container.querySelectorAll(this.selectors.video).forEach(e => {
      e.addEventListener("click", this.onVideoClick.bind(this));
    });
  }

  /**
   * Handle click on video
   * @param {PointerEvent} e Click event 
   */
  onVideoClick(e) { 
    const video = e.currentTarget;
    const slide = video.closest(this.selectors.slide);
    this.resetVideoSlide(slide);
  }

  /**
   * Handle click on play button
   * @param {PointerEvent} e Click event  
   */
  onVideoPlayButtonClick(e) {
    const slide = e.currentTarget.closest(this.selectors.slide);

    // This applies to ALL videos in the slider
    this.container.querySelectorAll(this.selectors.slide).forEach(element => {
      if (element !== slide) {
        this.resetVideoSlide(element);
      } else {
        this.activateVideoSlide(slide); 
      }
    });
  }

  /**
   * Reset a video slide
   * @param {HTMLElement} slide The slide to reset containing the video
   */
  resetVideoSlide(slide) {
    const video = slide.querySelector(this.selectors.video);
    const poster = slide.querySelector(this.selectors.poster);
    const button = slide.querySelector(this.selectors.button);

    // Video: pause, and set currentTime to 0
    video.pause();
    video.currentTime = 0;
    poster.classList.remove("opacity-0");
    button.classList.remove("opacity-0");
  }

  /**
   * Activate a video slide
   * @param {HTMLElement} slide The slide to activate containing the video
   */
  activateVideoSlide(slide) {
    const video = slide.querySelector(this.selectors.video);
    const poster = slide.querySelector(this.selectors.poster);
    const button = slide.querySelector(this.selectors.button);

    if (video.paused) {
      video.play();
      poster.classList.add("opacity-0");
      button.classList.add("opacity-0");
    } else {
      video.pause();
      poster.classList.remove("opacity-0");
      button.classList.remove("opacity-0");
    }
  }
}

export default VideoSlider;